/**
 * frontend/src/pages/valuation/_driverAnswers.ts
 *
 * WALKFIX-A AMEND-2 — what counts as an answered driver question, and which
 * questions a refused run names as unanswered.
 *
 * A saved answer that is no longer one of the question's options is NOT an
 * answer (the server refuses it the same as a blank), so it never counts.
 */
import type { DriverQuestion } from '@/types/valuation'

export function isAnswered(question: DriverQuestion, answers: Record<string, string>): boolean {
  const value = answers[question.question_id] ?? ''
  return value !== '' && question.options.some(o => o.value === value)
}

/** `error.details.unanswered_question_ids` from a refused (400) run, or []. */
export function unansweredIdsFromError(e: unknown): string[] {
  const ids = (e as { response?: { data?: { error?: { details?: { unanswered_question_ids?: unknown } } } } })
    ?.response?.data?.error?.details?.unanswered_question_ids
  return Array.isArray(ids) ? ids.filter((id): id is string => typeof id === 'string') : []
}
